<template>
  <b-modal id="modal-detail" ref="modal-det" size="lg" title="Detail" @show="setData" @hide="okHandle">
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend>General Information </legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-6 mb-3">
                    {{detail.emp_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Transaction Number</label>
                <div class="col-md-6 mb-3">
                  {{detail.number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Request Date</label>
                <div class="col-md-6 mb-3">
                  {{detail.request_date}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Project</label>
                <div class="col-md-6 mb-3">
                  {{detail.project_abbreviation}} - {{detail.var_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Activity Start</label>
                <div class="col-md-6 mb-3">
                  {{detail.activity_start}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">End of Activity</label>
                <div class="col-md-6 mb-3">
                  {{detail.activity_end}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Nominal Cash Advance</label>
                <div class="col-md-5 mb-3">
                  {{detail.cash_advance_amount}}
                </div>
                <div class="col-md-1 mb-2">
                  {{detail.curr_code}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Cash Advance Use</label>
                <div class="col-md-6 mb-3">
                    {{detail.cash_advance_purpose}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Mini TOR/Breakdown Budget</label>
                <div class="col-md-6 mb-3">
                  <a :href="detail.link_file" target="_blank">{{detail.attachment_enc}}</a>
                </div>
              </div>

              <hr>
              <legend>Approval Information</legend>
              <list-supervisor-finish :list_supervisor="list_supervisor" v-if="!arr_status.includes(detail.ca_stat_id)"></list-supervisor-finish>
              <list-supervisor :emp_id="detail.emp_id.toString()" v-else></list-supervisor>
            </div>
          </div>
        </div>
      </div>

    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="okHandle"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import {BModal, BForm} from "bootstrap-vue"
import ListSupervisor from "../employee/ListSupervisor";
import ListSupervisorFinish from "../employee/ListSupervisorFinish";
export default {
  name: "CashAdvanceDetail",
  props:{
    id:{
      type:Number,
    }
  },
  components:{
    ListSupervisorFinish,
    ListSupervisor,
    BModal,
    BForm
  },
  data(){
    return {
      detail:{},
      list_supervisor:[],
      arr_status :[0,1]
    }
  },
  methods:{
    okHandle(){
      this.$parent.id = null
      this.$refs["modal-det"].hide()
    },
    setData(){
      setTimeout(()=>{
        let payload = {id: this.id, lang:"en"}
        AxiosCall.Get(payload, urlApi.cash_advance.detail).then(res=>{
          if (res.success){
            this.detail=res.atributes
            this.detail.link_file = `${process.env.VUE_APP_URL_API}${res.atributes.attachment_path}`
            if(!this.arr_status.includes(this.detail.ca_stat_id)) this.getListSupervisor()
          }
        })
      }, 100)
    },
    getListSupervisor(){
      let payload = {
        id:this.id
      }
      AxiosCall.Get(payload, urlApi.cash_advance.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    }
  }
}
</script>